export default __webpack_public_path__ + "static/media/proposta.09ad14b7.pdf";